/** Presentation-only measurements; never used to classify forecast weather codes.
 * Input values are metric millimetres, before any user-selected unit conversion. */
export function validRain(value: number | null | undefined): number | null {
  return typeof value === "number" && Number.isFinite(value) && value >= 0
    ? value
    : null;
}

/** Label and color a metric rain rate using the rounded inch-per-hour intensity bands. */
export function rainIntensity(value: number | null | undefined) {
  const rate = validRain(value);
  if (rate === null)
    return { label: "Unavailable", color: "var(--rain-text)" };
  if (rate === 0)
    return { label: "Dry", color: "var(--weather-rain-rate-light)" };
  const displayedRate = Math.round(rate / 25.4 * 100) / 100;
  return (
    displayedRate < 0.1
      ? { label: "Light", color: "var(--weather-rain-rate-light)" }
      : displayedRate < 0.19
        ? { label: "Moderate", color: "var(--weather-rain-rate-moderate)" }
        : displayedRate < 0.42
          ? { label: "Heavy", color: "var(--weather-rain-rate-heavy)" }
          : { label: "Intense", color: "var(--weather-rain-rate-intense)" }
  );
}
